import { Component, Input, OnInit } from '@angular/core';
import { WebItem } from 'src/app/core/models/api/web-item.model';

@Component({
    selector: 'app-cards-lateral-image-list',
    templateUrl: './cards-lateral-image-list.component.html',
    styleUrls: ['./cards-lateral-image-list.component.scss']
})
export class CardsLateralImageListComponent implements OnInit {
    
    @Input() items: WebItem[];

    constructor() { }

    ngOnInit() { }

}
